import { DocumentOnView } from 'presentation/document/documentOnView';
import { DocumentModel } from 'shared/domain/document/documentModel';
import {
  isImageExtension,
  resolveExtensionFromMimeType,
} from 'shared/utils/fileExtensions';

export const isDocumentImage = (
  document: DocumentModel | DocumentOnView
): boolean => {
  const documentExtension = resolveExtensionFromMimeType(
    document.data?.type
  );

  if (typeof documentExtension !== 'string') {
    return false;
  }

  return isImageExtension(documentExtension);
};

export const getNextQuarterTurnRotation = (
  currentRotation?: number | null
): number => {
  const normalized =
    typeof currentRotation === 'number' && Number.isFinite(currentRotation)
      ? ((currentRotation % 360) + 360) % 360
      : 0;

  return (normalized + 90) % 360;
};
